import {normalize, schema, denormalize} from 'normalizr';

const postLanguage = new schema.Entity('postsLanguages', {}, {idAttribute: "id"});

export function normalizeDatos(myData) {

    const mySchema = {postsLanguages: [postLanguage]};
    const normalizedData = normalize(myData, mySchema);
    return normalizedData;
}


export function normalizeDato(myData) {

    const mySchema = postLanguage;
    const normalizedData = normalize(myData, mySchema);

    return normalizedData;
}

export function denormalizeDato(myData, store) {

    const mySchema = postLanguage;

    const normalizedData = denormalize(myData, mySchema, store);

    return normalizedData;
}

export default postLanguage;
